export default "__VITE_ASSET__BKFkxnPY__"